<template>
	<section class="visits">
		<!--Basic Box-->
		<div class="basic-box cabinet__basic-box">

			<visit-item v-for="event in visits" :key="event._id" :event="event"></visit-item>

			<!-- Pagination -->
			<pagination v-if="visits.length" :options="pagination" @trigger="loadPage"></pagination>
			<!-- Pagination End -->

			<span v-else>У Вас еще не было визитов</span>
		</div>
		<!--Basic Box-->

	</section>
</template>

<script>
	import moment from 'moment'
	import VisitItem from '@/components/VisitItem.vue'
	import Pagination from '@/components/Pagination.vue'
	import _ from 'underscore'

	const classes = {
		'not_confirmed': 'status_not-confirmed',
		'confirmed': 'status_confirmed',
		'came': 'status_performing',
		'canceled': 'status_canceled',
		'not_appeared': 'status_absence',
		'completed': 'status_done'
	}

	export default {
		name: "Visits",
		components: {VisitItem, Pagination},
		computed: {
			id() {
				return this.$route.params.id
			},
			pagination() {
				return {
					total: this.total,
					current: this.current_page
				}
			},
			isDoctor() {
				return this.$store.state.auth.isDoctor || this.$storage.isExist('worker')
			}
		},
		mounted() {
			this.getVisits(this.id, this.current_page)

			this.$event.connect('updateEvents', () => this.getVisits(this.id, this.current_page))
		},
		beforeDestroy() {
			this.$event.disconnect('updateEvents')
		},
		data() {
			return {
				visits: [],
				current_page: 1,
				total: 1
			}
		},
		methods: {
			getVisits(id, page) {
				let sendObject = {
					begin: moment().format('YYYY-MM-DD'),
					per_page: 20,
					sort: 'desc',
					current_page: page
				}

				sendObject[this.isDoctor ? 'worker_ids' : 'user_ids'] = [id]

				this.$store.dispatch('agenda/list', sendObject).then(list => {
					this.visits = list.data || []
					this.total = list.last_page || 1
				})
			},
			calcStatusClass(status) {
				return [classes[status]]
			},
			loadPage(page) {
				this.current_page = page
				this.getVisits(this.id, page)
			}
		}
	}
</script>



// WEBPACK FOOTER //
// Visits.vue?66bcd9c8